import { useEffect, useRef, useState } from "react";
import { ChevronDown, ExternalLink, LogOut, Shield } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/cn";
import { env } from "@/lib/env";

export function AdminTopbar() {
  const { user, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const initial = user?.name?.charAt(0).toUpperCase() ?? "?";

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center justify-between border-b border-admin-200 bg-white px-6">
      <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-admin-700">
        <Shield className="h-3.5 w-3.5" />
        Area administrativa
      </div>

      <div className="relative" ref={ref}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-2.5 rounded-lg px-2 py-1.5 transition-colors hover:bg-admin-50"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-admin-900 text-xs font-semibold text-white">
            {initial}
          </div>
          <div className="hidden text-left sm:block">
            <p className="text-sm font-medium text-admin-900 leading-tight">{user?.name}</p>
            <p className="text-xs text-admin-700/70 leading-tight">{user?.email}</p>
          </div>
          <ChevronDown
            className={cn("h-4 w-4 text-admin-700/50 transition-transform", open && "rotate-180")}
          />
        </button>

        {open && (
          <div className="absolute right-0 top-12 w-56 overflow-hidden rounded-xl border border-admin-200 bg-white shadow-lg">
            <div className="border-b border-admin-100 bg-admin-50/50 px-4 py-3">
              <p className="truncate text-sm font-semibold text-admin-900">{user?.name}</p>
              <p className="truncate text-xs text-admin-700">{user?.email}</p>
            </div>
            <div className="p-1.5">
              <a
                href={env.landingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 rounded-md px-2.5 py-2 text-sm text-admin-900 transition-colors hover:bg-admin-50"
              >
                <ExternalLink className="h-4 w-4 text-admin-700/50" />
                Ver site publico
              </a>
              <button
                type="button"
                onClick={() => signOut()}
                className="flex w-full items-center gap-2.5 rounded-md px-2.5 py-2 text-sm text-red-600 transition-colors hover:bg-red-50"
              >
                <LogOut className="h-4 w-4" />
                Sair
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
